// extracted by mini-css-extract-plugin
export default {"equipments":"styles_equipments__1+yVh","equipmentLine":"styles_equipmentLine__dKzUa","equipmentName":"styles_equipmentName__1gEO8","equipmentValue":"styles_equipmentValue__WOeid"};